import { AmplitudeEvent } from 'utils/amplitude/amplitudeEvents'

export const pageEventMap = {
  home: AmplitudeEvent.EARN_HOME,
  details: AmplitudeEvent.EARN_DETAILS,
}

export const formEventMap = {
  deposit: AmplitudeEvent.EARN_DEPOSIT_INITIATE,
  withdraw: AmplitudeEvent.EARN_WITHDRAW_INITIATE,
}

export const cancelEventMap = {
  deposit: AmplitudeEvent.EARN_DEPOSIT_CANCEL,
  withdraw: AmplitudeEvent.EARN_WITHDRAW_CANCEL,
}

export const successEventMap = {
  deposit: AmplitudeEvent.EARN_DEPOSIT_SUCCESS,
  createPortfolio: AmplitudeEvent.EARN_CREATE_PORTFOLIO_SUCCESS,
  withdraw: AmplitudeEvent.EARN_WITHDRAW_SUCCESS,
}

export const errorEventMap = {
  deposit: AmplitudeEvent.EARN_DEPOSIT_ERROR,
  createPortfolio: AmplitudeEvent.EARN_CREATE_PORTFOLIO_ERROR,
  withdraw: AmplitudeEvent.EARN_WITHDRAW_ERROR,
}
